// Classic › live: the live-events list and event page copy (#1119). The
// "Live Events" title is the glossary's term.

const en = {
  subtitle: 'Drafts, interviews, announcements, and more',
  loadError: 'Failed to load events',
  emptyTitle: 'No Events Yet',
  emptyBody: 'Check back soon for upcoming live events',
  liveNow: 'Live Now',
  upcoming: 'Upcoming',
  past: 'Past Events',
  /** The card badge on a live event. */
  liveBadge: 'LIVE',
  replay: 'Replay',
  notFoundTitle: 'Event Not Found',
  notFoundBody: 'This event does not exist',
  backToEvents: 'Back to Events',
  /** The chat iframe's title. */
  chatTitle: 'Live Chat',
  startingSoon: 'Event Starting Soon',
  streamSoon: 'The stream will appear here when the event goes live',
  about: 'About This Event',
}

export default en
